import { render } from "./ColorPicker.vue?vue&type=template&id=0ee8c34a"
import script from "./ColorPicker.vue?vue&type=script&lang=ts"
export * from "./ColorPicker.vue?vue&type=script&lang=ts"
script.render = render

export default script